import { motion } from "framer-motion";
import { AppleMark, PlayStoreMark } from "./BrandMarks";
import { STORE } from "../../data/site";

const ease = [0.22, 1, 0.36, 1];

const StoreButton = ({ mark, top, bottom, testId, href }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="group flex items-center gap-3 rounded-2xl border border-white/15 bg-white px-6 py-3.5 text-black transition-transform duration-300 hover:scale-[1.04] hover:shadow-[0_0_30px_rgba(255,255,255,0.3)]"
    data-testid={testId}
  >
    {mark}
    <span className="text-left leading-tight">
      <span className="block text-[10px] uppercase tracking-wider text-black/60">
        {top}
      </span>
      <span className="block font-display text-lg font-medium">{bottom}</span>
    </span>
  </a>
);

export const Download = () => (
  <section
    id="download"
    className="relative z-10 mx-auto max-w-6xl px-6 py-28 md:py-40"
    data-testid="download-section"
  >
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1, ease }}
      className="relative overflow-hidden rounded-[3rem] border border-white/10 bg-white/[0.03] px-8 py-16 text-center backdrop-blur-2xl md:px-16 md:py-24"
    >
      <div className="absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-[#7c3aed] blur-[130px] opacity-30" />
      <div className="absolute -bottom-24 right-0 h-72 w-72 rounded-full bg-[#ffb7b2] blur-[130px] opacity-25" />

      <span className="relative inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs uppercase tracking-[0.25em] text-white/70">
        The Radiate difference
      </span>

      <h2 className="relative mt-8 font-display text-4xl font-extralight leading-[1.08] tracking-tight text-white md:text-6xl">
        Most tools try to change your thoughts.
        <br />
        <span className="italic text-white/80">
          Radiate changes the state you're thinking from.
        </span>
      </h2>

      <p className="relative mx-auto mt-7 max-w-md text-base leading-relaxed text-white/60 md:text-lg">
        Download Radiate and start with a full week free — every guided
        meditation, breathwork session and daily prompt, on us.
      </p>

      <div className="relative mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
        <StoreButton
          mark={<AppleMark className="h-7 w-7 text-black" />}
          top="Download on the"
          bottom="App Store"
          testId="download-app-store"
          href={STORE.appStore}
        />
        <StoreButton
          mark={<PlayStoreMark className="h-7 w-7" />}
          top="Get it on"
          bottom="Google Play"
          testId="download-google-play"
          href={STORE.googlePlay}
        />
      </div>

      <p className="relative mt-8 text-xs uppercase tracking-[0.2em] text-white/35">
        One week free · New sessions added every week
      </p>
    </motion.div>
  </section>
);
